import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap'
import Auth from '@aws-amplify/auth';

import NewPassword from './NewPassword'
import Settings from '../../utils/Settings'
import { generateAuthLink, THEME_DEFAULT } from '../../utils/common'

import { useStyles } from '../../styles/LoginStyles'
import { getOrgByUser, verify } from '../../utils/Users';
import { parseTheme } from '../../utils/common'

import poweredBy from '../../../assets/images/powered-by.png'

import { initAuthData, isAuthenticated, removeRedirect, userCheckAsync } from '../../../features/session/sessionSlice';
import history from '../../../history'
import NonAuthHeader from '../Layout/NonAuthHeader';

const INITIAL_STATE = { 
    email: "",
    key: null,
    password: "",
    posting: false,
    showLogin: true,
    showPasswordForm: false,
    unauthorized: false,
    user: {},
    $state: null,
    formTitle: "Dashboard Login",
    logoDir: "",
    challenge: null,
    imported: false,
    loadVerification: false
}

function Login(props){

    const [state,setState] = useState(INITIAL_STATE)
    const dispatch = useDispatch()
    const session = useSelector(state => state.session)
    const theme = parseTheme()
    const isAuth = useSelector(isAuthenticated);
    
    useEffect(() => {
        if(props?.match?.params){
            performVerification()
        }
        
        return () => setState(prev => ({
            ...prev,
            imported: true
        }))
    }, [])
    useEffect(() => {
        if(!state.showPasswordForm && session?.user?.challengeName){
            try {
                if(session.user?.challengeName){
                    if(session.user.challengeName === "NEW_PASSWORD_REQUIRED"){
                        setState(prevState => ({
                            ...prevState,
                            showPasswordForm: true,
                            showLogin: false,
                            formTitle: "Set Password",
                            user: session.user
                        }))
    
                    } else {
                        throw new Error("Unauthorized: Password already verified")
                    }
                } else {
                    throw new Error("Unauthorized: Password already verified")
                }
            } catch(e) {
                setState(prevState => ({
                    ...prevState,
                    unauthorized: true,
                    showLogin: false
                }))
            }
        }

    }, [session?.user])

    const performVerification = async() => {        
        setState(prev => ({
            ...prev,
            loadVerification: true
        }))

        const {response, error } = await verify(props.match.params.code)
        try {
            if(response.error){
                throw new Error("Unauthorized")
            }
            
            const resp = await dispatch(userCheckAsync(response))

            const { error, granted, user } = resp.payload

            await setState(prev => ({
                ...prev,
                loadVerification: false
            }))
            
        } catch(e) {
            toast.error("Error: Your verification link has expired.")
            console.log(e)
            await setState(prevState => ({
                ...prevState,
                unauthorized: true,
                loadVerification: false
            }))

            setTimeout(() => {
                history.push("/login")
            }, 2500)
        }
    }

    const submitForm = async(e) =>{
        if(e){
            e.preventDefault()
        }

        const { email, password, setting, $state } = state
        setState(prevState => ({
            ...prevState,
            posting: true
        }))

        try {
            const resp = await dispatch(userCheckAsync({email, password}))

            const { error, granted, user } = resp.payload
        
            if(error){
                setState(prevState => ({
                    ...prevState,
                    posting: false
                }))
                toast.error("Email or password is incorrect. Please try again", {containerId: "loginToastContainer"})
            } else if (user) {

                if(user.challengeName){
                    if(user.challengeName === "NEW_PASSWORD_REQUIRED"){
                        setState(prevState => ({
                            ...prevState,
                            showPasswordForm: true,
                            showLogin: false,
                            formTitle: "Change Password",
                            user
                        }))
                    }
        
                } else {
        
                    if(!granted){
                        setState(prevState => ({
                            ...prevState,
                            posting: false
                        }))
                        if(import.meta.env.MODE === "production" && Settings.origin === Settings.oldOrigin){
                            toast.error("Redirecting to new website. Please wait", {containerId: "loginToastContainer"})
                            setTimeout(() => {
                                window.location.href = THEME_DEFAULT.origin
                            }, 5000)                            
                        } else {
                            toast.error("Access denied. Please contact the system administrator", {containerId: "loginToastContainer"})
                        }
                    } else {
                        await dispatch(initAuthData())
                        // let redirect = sessionStorage.getItem('redirect') ? sessionStorage.getItem('redirect'): false
                        
                        // if(session.isAuthenticated){
                        //   if(redirect){
                        //     sessionStorage.removeItem("redirect")
                        //     history.push(redirect)
                              
                        //   } else {
                        //     history.push("/traffic-performance")                        
                        //   }
                        // }
                    }
                }
            }
        } catch(e){
            setState(prevState => ({
                ...prevState,
                posting: false
            }))
            toast.error("Email or password is incorrect. Please try again", {containerId: "loginToastContainer"})
        }
        
    }

    const handleKeyPress = (e) => {
        let code = e.keyCode || e.which;
        if(code == 13) {
            submitForm(e)
        }
    }

    const onPasswordFormSubmit = async(s) =>{
        try{
            const { user } = state

            const u = await Auth.completeNewPassword(
                user,
                s.password,
                {
                    given_name: s.givenName,
                    family_name: s.familyName
                }
            )

            localStorage.setItem('token', u.signInUserSession.idToken.jwtToken)

            window.location.href = "/"
        } catch(e){
            toast.error(e.message, {containerId: "loginToastContainer"})
        }
    }

    const { logoDir, posting, showLogin, showPasswordForm, formTitle, user, loadVerification } = state

    const classes = useStyles()

    return <>
        <NonAuthHeader />
        <div className="container container-padded">
            <Row className={classes.container}>
                {!isAuth && <ToastContainer
                    containerId="loginToastContainer"
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                    />}
                <Col xs="12" sm="12" md="8" lg="6" xl="6" className="form mx-auto p-4">
                    {loadVerification && <div class="spinner-border mx-auto d-block" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>}
                    <div className="row pt-4">
                        <div className="col"><hr /></div>
                        <div className="col-auto">{formTitle.toUpperCase()}</div>
                        <div className="col"><hr /></div>
                    </div>
                    {showLogin && <form id="signInForm" className="justify-content-center" method="POST" onSubmit={e => submitForm(e)}>
                        <div className="form-group">
                            <input type="email" onKeyPress={e => handleKeyPress(e)} onChange={e => setState({...state, email: e.target.value})} className="form-control input-lg" placeholder="Email" name="email" required="" />
                        </div>

                        <div className="form-group">
                            <input type="password" onKeyPress={e => handleKeyPress(e)} onChange={e => setState({...state, password: e.target.value})} className="form-control input-lg" placeholder="Password" name="password" required="" />
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-success btn-lg btn-block">
                                {posting && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                {!posting && <i className="fa fa-lock pr-2"></i>}
                                    Log In
                            </button>
                        </div>
                    </form>}
                    {showPasswordForm &&<NewPassword user={user} onSubmit={state => onPasswordFormSubmit(state)} />}
                    <p className="text-center">
                        While results may vary, clicking Log In can greatly increase your level of marketing analytics knowledge…be prepared.
                        <Link className="mt-3 d-block" to="/forgot-password">Forgot Your Password?</Link>
                    </p>
                    <img className="img-fluid mx-auto d-block mb-3" src={poweredBy} style={{
                        maxHeight: "100px",
                        ...(session.useDarkMode ? {filter: "brightness(0) invert(1)"} : {})
                    }} />
                    <a className="text-center d-block" href="https://internetstrategylabs.com/privacy-policy/" target="_blank">
                        Privacy Policy
                    </a>
                </Col>
            </Row>
        </div>
    </>

}

export default Login